<template>
  <div class="stripe-button p-fluid">
    <a href="/stripe/board">
      <Button class="p-button-md p-justify-center">
        <span class="stripe-icon"></span>
        Connect Stripe
      </Button>
    </a>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
@import '../assets/sass/theme_variables';

.stripe-button {
  .p-button {
    background: #6273E9;
    box-shadow: none;
  }

  a {
    text-decoration: none;
  }
}

.stripe-icon {
  display: inline-block;
  width: toRem(24);
  height: toRem(24);
  margin: -3px 0;
  background: url("../assets/images/stripe-icon.svg") 0 0 no-repeat;
}
</style>
